var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlame = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "23px",
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3A22D275-E33A-429A-A5E7-0C1C46C0CC9D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Preparer",
    transform: "translate(-47.000000, -363.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(30.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Price-Free",
    transform: "translate(6.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/Flamme",
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79008929,23 C3.05785714,23 0,19.7766753 0,14.7883714 C0,10.2588888 3.44464286,6.3223442 3.59142857,6.15716857 C3.72589286,6.00526347 3.928125,5.9439932 4.11991071,5.99679293 C4.310625,6.04987501 4.45821429,6.20912125 4.50401786,6.41156727 C4.78633929,7.65617267 5.20044643,8.90586039 5.47232143,9.37625798 C5.90142857,8.94906016 6.74116071,7.75330158 6.9675,5.57128922 C7.25008929,2.84857375 6.43607143,0.808584191 6.4275,0.788254883 C6.33133929,0.55164433 6.39910714,0.275786918 6.59223214,0.118234784 C6.78508929,-0.0390349996 7.05482143,-0.0398820541 7.24794643,0.118517135 C7.36178571,0.211693129 10.0577679,2.4332347 11.9978571,5.28893773 C13.2867857,7.18662213 15,10.2038302 15,14.4823024 C15,19.4974297 12.0353571,23 7.79008929,23 Z",
    id: "Flamme"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flame.6b3c39d6a6599a940c00c2c64be5231e.svg";